import deparam from 'node-jquery-deparam';

export default class Browser {
  static getQueryParams() {
    const paramString = Browser.getWindow().location.search;

    return deparam(paramString.substring(1));
  }

  static getWindow() {
    return window;
  }
}



// WEBPACK FOOTER //
// ./src/shared/helpers/browser.js